import { Trans } from '@lingui/react/macro';

import type {
  ZuubDeductibleRow,
  ZuubMaximumDeductibleRow,
} from '@/@types/zuub/contracts';

import { BenefitsTable } from '../common/BenefitsTable';

interface MaximumsAndDeductiblesTableProps {
  data: ZuubMaximumDeductibleRow[] | ZuubDeductibleRow[];
  title: string;
}

export const MaximumsAndDeductiblesTable = ({
  data,
  title,
}: MaximumsAndDeductiblesTableProps) => {
  const formatCurrency = (value: number | null) => {
    if (value === null) return 'N/A';
    return `$${value.toFixed(2)}`;
  };

  const columns = [
    { header: <Trans>Service Type</Trans>, align: 'left' as const },
    { header: <Trans>Individual</Trans>, align: 'center' as const },
    { header: <Trans>Family</Trans>, align: 'center' as const },
    { header: <Trans>Plan Period</Trans>, align: 'center' as const },
  ];

  const rows = data.map((item, index) => ({
    key: `${item.serviceType}-${index}`,
    cells: [
      item.serviceType,
      formatCurrency(item.individual),
      formatCurrency(item.family),
      item.planPeriod ?? 'N/A',
    ],
  }));

  return (
    <div className="vai-w-full">
      <h3 className="vai-text-lg vai-font-semibold vai-text-foreground vai-mb-4">
        {title}
      </h3>
      <BenefitsTable
        columns={columns}
        rows={rows}
        emptyMessage={`No ${title.toLowerCase()} data available.`}
      />
    </div>
  );
};
